import api from "@/services/api";

export const state = {
  places: [],
  place: {},
};

export const mutations = {
  INIT_PLACES(state, payload) {
    state.places = payload;
  },
  INIT_PLACE(state, payload) {
    state.place = payload;
  },
};

export const actions = {
  getPlaces({ commit }, payload) {
    return api.getPlaces(payload).then((response) => {
      commit("INIT_PLACES", response.data.data);

      if (!payload.retrieveAll) commit("pager/INIT_PAGER", response.data.pagedResult, { root: true });
    });
  },
  getPlaceById({ commit }, payload) {
    return api.getPlaceById(payload).then((response) => {
      commit("INIT_PLACE", response.data.data);
    });
  },
};

export const getters = {
  getPlaces: (state) => state.places,
  getPlace: (state) => state.place,
};
